import LocationUtil from "../common/util/LocationUtil";
import Fader from "../common/view/Fader";
import Group from "./Group";
import ResultPoint from "./ResultPoint";
import ResultModal from "./ResultModal";
import { CATEGORY_NAME } from "../constants/variables";
import DataManager from "../common/core/DataManager";

class Result {
  // ---------------------------------------------------------------------------------------------------------
  // --	Result
  // ---------------------------------------------------------------------------------------------------------

  constructor() {
    //フェーダー
    this.fader = new Fader();

    //モーダル
    this.modal = new ResultModal();

    //集計画面
    this.point = new ResultPoint();

    //もういちどボタン
    $(".js-retry-btn").on("click", this.onRetry.bind(this));

    //URLパラメーターのチェック
    if (
      !LocationUtil.getParam("answers") ||
      LocationUtil.getParam("answers").length < 20
    ) {
      console.log("回答データが不正です。");
      location.href = "index.html";
      return;
    }

    //CSV読み込み
    this.loadCsv();
  }

  /**
   * CSV読み込み
   */
  loadCsv() {
    $.get("./assets/data/data.csv").done((csv) => {
      this.models = $.csv.toObjects(csv);
      this.loadTemplate();
    });
  }

  /**
   * テンプレート読み込み
   */
  loadTemplate() {
    //テンプレート読み込み
    $.get("./assets/data/answers-group.tmpl.html").done((data) => {
      this.tmpl = $.templates(data);
      this.start();
    });
  }

  /**
   * スタート
   */
  start() {
    //回答内容をモデルに反映
    const answers = LocationUtil.getParam("answers");
    const len = this.models.length;
    for (let i = 0; i < len; i++) {
      const model = this.models[i];
      model.selected = answers.charAt(i);
      model.isCorrect = model.correct === model.selected;
      model.answers = answers;
    }
    DataManager.setData("models", this.models);

    //レンダリング用に整形
    const categories = [];
    for (let i = 0; i < 5; i++) {
      //カテゴリークラス
      const catClass = "cat" + (i + 1);

      //モデル配列
      const models = this.models.filter((model) => model.cat === catClass);

      //スコア集計全問正解かどうか
      let score = 0;
      let isPerfect = true;
      for (let i = 0; i < models.length; i++) {
        const model = models[i];
        if (!model.isCorrect) {
          isPerfect = false;
        } else {
          score += 5;
        }
      }

      //モデル生成
      const catModel = {
        cat: catClass,
        label: CATEGORY_NAME[i + 1],
        isPerfect: isPerfect,
        score: score,
        models: models,
      };

      //配列に格納
      categories.push(catModel);
    }

    //レンダリング
    this.render(categories);

    //問題の指定があるかどうか判別
    let qIndex = -1;
    let groupIndex = -1;
    if (LocationUtil.getParam("q")) {
      qIndex = parseInt(LocationUtil.getParam("q")) - 1;
      groupIndex = Math.floor(qIndex / 4);
    }

    //グループを初期化
    $(".pg-result__answers-group").each(function (index) {
      const group = new Group($(this));
      if (index == groupIndex) group.open(0);
    });

    //問題の指定がある場合はそこに移動
    if (qIndex >= 0) {
      $("body, html").animate(
        {
          scrollTop:
            $(".pg-result__answers-list-item").eq(qIndex).position().top - 60,
        },
        500
      );
    }

    //モーダル用のボタン設定
    const holder = this;
    $(".js-exp-btn").each(function (index) {
      $(this).click((e) => {
        holder.showModal(index);
        return false;
      });
    });

    //集計画面の準備
    this.point.ready(categories, () => {
      //フェードでスタート
      this.fader.hide(() => {
        this.point.start();
      });
    });
  }

  /**
   * レンダリング
   */
  render(categories) {
    const result = this.tmpl.render({ categories: categories });
    $(".pg-result__answers-wrapper").html(result);
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	ACTION
  // ---------------------------------------------------------------------------------------------------------

  /**
   * モーダルを開く
   */
  showModal(index) {
    this.modal.open(index);
  }

  /**
   * リトライ
   */
  onRetry(e) {
    this.fader.changeCategory("cat1");
    this.fader.show(() => {
      location.href = "quiz.html";
    });
    return false;
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Result;
